import React, { useState } from 'react';
import './LandingPage.css';
import ContactFormModal from './components/ContactFormModal';
import {
  IconScatter, IconCpu, IconTrendingUp, IconDownload,
  IconTarget, IconLayers, IconMessage, IconType, IconMap, IconPieChart,
  IconShoppingBag, IconPackage, IconBriefcase, IconCoffee, IconLandmark, IconShoppingCart
} from './components/Icons';

function LandingPage({ onGetStarted }) {
  const [contactOpen, setContactOpen] = useState(false);
  return (
    <div className="landing-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-brand">
            <img src="/logo_openend.png" alt="OpenEnd Clusters" className="hero-logo" />
            <span className="hero-brand-name">OpenEnd Clusters</span>
          </div>
          <h1 className="hero-title">
            Универсальный Анализатор Открытых Вопросов
          </h1>
          <p className="hero-subtitle">
            Автоматическое кодирование и семантическая кластеризация ответов на открытые вопросы опросов
          </p>
          <p className="hero-description">
            Инновационный инструмент на базе искусственного интеллекта для анализа текстовых данных, 
            оптимизированный для русского языка. Обрабатывайте тысячи ответов за минуты, а не дни.
          </p>
          <button className="cta-button" onClick={onGetStarted}>
            Начать анализ →
          </button>
        </div>
        <div className="hero-visual">
          <div className="visual-container">
            <div className="floating-card card-1">
              <span className="card-icon"><IconScatter size={24} /></span>
              <span>Кластеризация</span>
            </div>
            <div className="floating-card card-2">
              <span className="card-icon"><IconCpu size={24} /></span>
              <span>ИИ Анализ</span>
            </div>
            <div className="floating-card card-3">
              <span className="card-icon"><IconTrendingUp size={24} /></span>
              <span>Визуализация</span>
            </div>
            <div className="floating-card card-4">
              <span className="card-icon"><IconDownload size={24} /></span>
              <span>Экспорт</span>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section" id="features">
        <h2 className="section-title">Ключевые возможности</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon"><IconTarget size={28} /></div>
            <h3>Двухэтапная кластеризация</h3>
            <p>
              Точная классификация каждого ответа с последующей агрегацией по респондентам 
              для определения доминирующих тем.
            </p>
          </div>
          <div className="feature-card">
            <div className="feature-icon"><IconLayers size={28} /></div>
            <h3>Мульти-отраслевые ядра</h3>
            <p>
              Готовые семантические модели для пищевых продуктов, непродовольственных товаров, 
              сферы услуг, органолептики, банков и финансов. Скоро — ритейл и маркетплейсы.
            </p>
          </div>
          <div className="feature-card">
            <div className="feature-icon"><IconMessage size={28} /></div>
            <h3>Обработка нескольких вопросов</h3>
            <p>
              Интеллектуальный анализ опросов с несколькими открытыми вопросами 
              (Q1, Q2, Q3 и т.д.).
            </p>
          </div>
          <div className="feature-card">
            <div className="feature-icon"><IconType size={28} /></div>
            <h3>Русский NLP движок</h3>
            <p>
              Использует pymorphy3 для точной лемматизации и предобработки 
              русского текста.
            </p>
          </div>
          <div className="feature-card">
            <div className="feature-icon"><IconMap size={28} /></div>
            <h3>Визуализация кластеров</h3>
            <p>
              Интерактивная 2D карта кластеров на основе t-SNE для выявления 
              паттернов в данных.
            </p>
          </div>
          <div className="feature-card">
            <div className="feature-icon"><IconPieChart size={28} /></div>
            <h3>Продвинутый экспорт</h3>
            <p>
              Детальные Excel отчеты с ID респондентов, оригинальными ответами, 
              категориями и оценками уверенности.
            </p>
          </div>
        </div>
      </section>

      {/* Industries Section */}
      <section className="industries-section">
        <h2 className="section-title">Отраслевые решения</h2>
        <div className="industries-grid">
          <div className="industry-card food">
            <div className="industry-icon"><IconShoppingBag size={32} /></div>
            <h3>Пищевые продукты</h3>
            <ul className="industry-features">
              <li>Вкус и аромат</li>
              <li>Цена и ценность</li>
              <li>Качество ингредиентов</li>
              <li>Доступность в магазинах</li>
              <li>Разнообразие ассортимента</li>
            </ul>
          </div>
          <div className="industry-card non-food">
            <div className="industry-icon"><IconPackage size={32} /></div>
            <h3>Непродовольственные товары</h3>
            <ul className="industry-features">
              <li>Эффективность продукта</li>
              <li>Состав и безопасность</li>
              <li>Аромат и текстура</li>
              <li>Упаковка и дизайн</li>
              <li>Ощущения при использовании</li>
            </ul>
          </div>
          <div className="industry-card services">
            <div className="industry-icon"><IconBriefcase size={32} /></div>
            <h3>Сфера услуг</h3>
            <ul className="industry-features">
              <li>Работа персонала</li>
              <li>Скорость обслуживания</li>
              <li>Надежность сервиса</li>
              <li>Решение проблем</li>
              <li>Общее впечатление</li>
            </ul>
          </div>
<div className="industry-card organoleptic">
            <div className="industry-icon"><IconCoffee size={32} /></div>
            <h3>Органолептика (продуктовые тесты)</h3>
            <ul className="industry-features">
              <li>Вкус и послевкусие</li>
              <li>Аромат и запах</li>
              <li>Текстура и консистенция</li>
              <li>Внешний вид продукта</li>
              <li>Баланс сладости и солёности</li>
            </ul>
          </div>
<div className="industry-card finance">
            <div className="industry-icon"><IconLandmark size={32} /></div>
            <h3>Банки и финансы</h3>
            <ul className="industry-features">
              <li>Мобильное приложение и онлайн-банк</li>
              <li>Работа отделений и персонала</li>
              <li>Тарифы и комиссии</li>
              <li>Кредиты, вклады и карты</li>
              <li>Поддержка и решение проблем</li>
            </ul>
          </div>
<div className="industry-card retail">
            <div className="industry-badge">Скоро</div>
            <div className="industry-icon"><IconShoppingCart size={32} /></div>
            <h3>Ритейл и маркетплейсы</h3>
            <ul className="industry-features">
              <li>Доставка и сроки</li>
              <li>Соответствие товара описанию</li>
              <li>Упаковка при доставке</li>
              <li>Возвраты и споры</li>
              <li>Пункты выдачи и сервис</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits-section">
        <h2 className="section-title">Преимущества для вашего бизнеса</h2>
        <div className="benefits-grid">
          <div className="benefit-item">
            <div className="benefit-number">10x</div>
            <div className="benefit-text">Быстрее ручной кодировки</div>
          </div>
          <div className="benefit-item">
            <div className="benefit-number">95%</div>
            <div className="benefit-text">Точность классификации</div>
          </div>
          <div className="benefit-item">
            <div className="benefit-number">∞</div>
            <div className="benefit-text">Объем обрабатываемых данных</div>
          </div>
          <div className="benefit-item">
            <div className="benefit-number">24/7</div>
            <div className="benefit-text">Автоматическая обработка</div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="how-it-works">
        <h2 className="section-title">Как это работает</h2>
        <div className="steps-container">
          <div className="step-item">
            <div className="step-number">1</div>
            <h3>Выбор отрасли</h3>
            <p>Выберите подходящую семантическую модель для вашей сферы</p>
          </div>
          <div className="step-connector">→</div>
          <div className="step-item">
            <div className="step-number">2</div>
            <h3>Загрузка данных</h3>
            <p>Импортируйте файл с ответами на открытые вопросы (CSV или Excel)</p>
          </div>
          <div className="step-connector">→</div>
          <div className="step-item">
            <div className="step-number">3</div>
            <h3>Анализ</h3>
            <p>Система выполнит двухэтапную кластеризацию и покажет результаты</p>
          </div>
          <div className="step-connector">→</div>
          <div className="step-item">
            <div className="step-number">4</div>
            <h3>Экспорт</h3>
            <p>Скачайте детальный отчет в Excel для дальнейшего использования</p>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="pricing-section" id="pricing">
        <h2 className="section-title">Гибкие тарифы под ваши задачи</h2>
        <p className="section-subtitle">Выберите подходящий уровень автоматизации для вашего проекта</p>
        
        <div className="pricing-table-container">
          <table className="pricing-table">
            <thead>
              <tr>
                <th className="feature-col">Возможность</th>
                <th className="plan-col basic">Базовый (без ИИ)</th>
                <th className="plan-col standard">Стандарт (с ИИ)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="feature-name">Модель оплаты</td>
                <td>За один проект</td>
                <td>Месячная подписка</td>
              </tr>
              <tr>
                <td className="feature-name">Кластеризация</td>
                <td>Базовая</td>
                <td><span className="highlight-text">Продвинутая (ИИ)</span></td>
              </tr>
              <tr>
                <td className="feature-name">Редактирование</td>
                <td>Ручное</td>
                <td><span className="highlight-text">ИИ-ассистент</span></td>
              </tr>
              <tr>
                <td className="feature-name">Разработчик ядра ИИ</td>
                <td>Нет</td>
                <td><span className="highlight-text">Да (обучение модели)</span></td>
              </tr>
              <tr>
                <td className="feature-name">Визуализация</td>
                <td>Excel</td>
                <td><span className="highlight-text">Excel + Интерактивные карты + Инсайты</span></td>
              </tr>
              <tr className="price-row">
                <td className="feature-name">Стоимость без НДС</td>
                <td>
                  <div className="price">4 990 руб.</div>
                  <div className="price-note">за один проект</div>
                </td>
                <td>
                  <div className="price">19 990 руб.</div>
                  <div className="price-note">до 5 проектов</div>
                  <div className="price-divider"></div>
                  <div className="price">39 990 руб.</div>
                  <div className="price-note">до 10 проектов</div>
                  <div className="price-divider"></div>
                  <div className="price">69 990 руб.</div>
                  <div className="price-note">безлимит</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-content">
          <h2>Готовы начать анализ?</h2>
          <p>Присоединяйтесь к тысячам исследователей, которые уже используют наш инструмент</p>
          <button className="cta-button-large" onClick={onGetStarted}>
            Войти в систему
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="landing-footer">
        <div className="footer-content">
          <div className="footer-column">
            <h4>Продукт</h4>
            <ul className="footer-links">
              <li><a href="#features">Возможности</a></li>
              <li><a href="#pricing">Тарифы</a></li>
              <li><a href="/blog/">Блог</a></li>
              <li><a href="#register" onClick={onGetStarted}>Регистрация</a></li>
            </ul>
          </div>
          <div className="footer-column">
            <h4>Компания</h4>
            <ul className="footer-links">
              <li><a href="/privacy.html">Политика конфиденциальности</a></li>
              <li><a href="/terms.html">Условия использования</a></li>
              <li><a href="/offer.html">Оферта</a></li>
            </ul>
          </div>
          <div className="footer-column">
            <h4>Контакты</h4>
            <ul className="footer-links footer-contacts-list">
              <li><button type="button" className="footer-link-button" onClick={() => setContactOpen(true)}>Напишите нам</button></li>
              <li><a href="mailto:support@crea-project.ru">support@crea-project.ru</a></li>
              <li><a href="https://crea-project.ru" target="_blank" rel="noopener noreferrer">crea-project.ru</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>© 2026 ООО «КреаМетрикс Рисеч». Все права защищены.</p>
        </div>
      </footer>

      <ContactFormModal isOpen={contactOpen} onClose={() => setContactOpen(false)} />
    </div>
  );
}

export default LandingPage;
